import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { RedBookVehicleUsedPriceCalculatedResponse } from '../../../types/redbook';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getRedBookVehicleUsedPriceCalculated = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<
  NonPaginatedResponse<RedBookVehicleUsedPriceCalculatedResponse> | undefined
> =>
  constructGet<NonPaginatedResponse<RedBookVehicleUsedPriceCalculatedResponse>>(
    `${PLUGIN_BASE_PATH}/red-book-request/list-car-vehicle-used-price-calculated`,
    { params },
  );
